export default {
    mounted(){
        if(typeof this.options === 'string'){
            let strArr = this.options.split('.');
            if(strArr.length === 3){
                if(app.dataproviders[strArr[0]] && app.dataproviders[strArr[0]].result) this.onReady = true;
            }else if(strArr.length === 2){
                if(this.$parent.data_provider_ref && this.$parent.data_provider_ref.result ) this.onReady = true;
            }
            setTimeout(() => {
                this.onReady = true;
            }, 2000);
        }else{
            this.onReady = true;
        }
    },
    data(){
      return{
        onReady: false,
      }
    }
};